import GetRegistrationData from "./PivotWithData";

function RegistrationDynamicReport() {
  return <GetRegistrationData />;
}

export default RegistrationDynamicReport;
